// 原始班级api
import { baseRequest, fileRequest } from './base'

/**
 * @desc 查询学生列表
 */
function getgradeList(params) {
    console.log('params', params);

    //清除空白字段
    params = utils.common.checkNull(params);
    let tempUrl = '/api/pcWeb/teaGrade/grandList/' + params.schoolId
    return baseRequest(tempUrl, 'get', params);
}



/**
 * @desc 退档处理
 */
function archive(params) {
    return baseRequest(`/api/pcWeb/teaGrade/archive`, 'post', params);
}

/**
 * @desc 升级班级
 */
function upGrade(params) {
    return baseRequest(`/api/pcWeb/teaGrade/upGrade`, 'post', params);
}

/**
 * @desc 获取升学目标年级选项列表
 */
 function upGradeName(params) {
    return baseRequest(`api/pcWeb/teaGrade/upGradeName`, 'get', params);
}

/**
 * @desc 新升级班级
 */
 function upGradeV2(params) {
    return baseRequest(`api/pcWeb/teaGrade/upGradeV2`, 'post', params);
}




export default {
    getgradeList: getgradeList,
    archive: archive,
    upGrade: upGrade,
    upGradeName: upGradeName,
    upGradeV2: upGradeV2
}